import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/pro-regular-svg-icons";

import Button from "ui/Button";

function GridPageControls({
  label,
  prevDisabled,
  nextDisabled,
  onPrev,
  onNext,
}: {
  label: string;
  prevDisabled: boolean;
  nextDisabled: boolean;
  onPrev: () => void;
  onNext: () => void;
}) {
  return (
    <>
      <span className="mr-[8px]">{label}</span>
      <Button
        bare
        aria-label="Previous page"
        className="!text-[18px] !py-0 !px-[8px] disabled:text-[#999] disabled:cursor-not-allowed"
        disabled={prevDisabled}
        onClick={onPrev}
      >
        <FontAwesomeIcon icon={faAngleLeft} />
      </Button>
      <Button
        bare
        aria-label="Next page"
        className="!text-[18px] !py-0 !px-[8px] disabled:text-[#999] disabled:cursor-not-allowed"
        disabled={nextDisabled}
        onClick={onNext}
      >
        <FontAwesomeIcon icon={faAngleRight} />
      </Button>
    </>
  );
}

export default GridPageControls;
